import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import './TermsAndConditions.css';

const TermsAndConditions = ({ show, onHide }) => {
  const [legalContent, setLegalContent] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (show) {
      setIsLoading(true);
      // Fetch the same Markdown file used in Footer
      fetch('/Totly%20legal.md')
        .then(response => {
          if (!response.ok) {
            throw new Error('Failed to load legal content');
          }
          return response.text();
        })
        .then(text => {
          setLegalContent(text);
          setIsLoading(false);
        })
        .catch(error => {
          console.error('Error loading legal content:', error);
          setError('Unable to load terms and conditions.');
          setIsLoading(false);
        });
    }
  }, [show]);

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered
      size="lg"
      dialogClassName="terms-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Terms and Conditions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="terms-content">
          {isLoading ? (
            <div className="text-center p-4">
              <p>Loading legal information...</p>
            </div>
          ) : error ? (
            <div className="alert alert-danger">{error}</div>
          ) : (
            <div className="markdown-content">
              <ReactMarkdown>{legalContent}</ReactMarkdown>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>I Understand and Accept</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsAndConditions; 